import React,{ Component } from "react";
import { connect } from "react-redux";
import { getManagers, deleteManager } from "../../actions/actionManager";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import { NotificationManager } from "react-notifications";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import { fuzzySearch } from "../../utils/helpers";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Manager",path:"/managers",isActive: true}
];

class Managers extends Component{
    constructor(props) {
        super(props);        
        this.state = {
            modal: false,
            pages: 1,
            managerId: null
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteManagerAction = this.deleteManagerAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount(){
        this.props.getManagers();
    }

    deleteConfirm(managerId){
        this.setState({modal: !this.state.modal, managerId: managerId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    deleteManagerAction(){
        this.props.deleteManager(this.state.managerId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteManagerErrorMessage} = this.props;
        if(deleteManagerErrorMessage) {
            NotificationManager.error(deleteManagerErrorMessage,"Delete Manager", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.success("Manager Deleted Successfully","Delete Manager", 3000);
            this.setState({modal: false});
            this.props.getManagers();
        }
    }

    handleDeleteError(){
        const {deleteManagerError} = this.props;
        if(deleteManagerError){
            NotificationManager.error(deleteManagerError,"Delete Manager", 3000);
            this.setState({modal: false});
        }
        else{
            NotificationManager.error("Delete Manager Failed","Delete User", 3000);
            this.setState({modal: false});
        }
    }

    render(){
        if (this.props.getManagersLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const { managers } = this.props;
        const { loading } = this.state;
        const columns = [{
            Header: "Host Name",
            accessor: "manager_hostname",
            filterMethod: fuzzySearch
        },
        {
            Header: "Last Reported",
            accessor: "last_reported_elapsed",
            filterable: false,
            sortable: false
        },
        {
            Header: "Zone",
            accessor: "zone_name",
            filterMethod: fuzzySearch

        },
        {
            Header: "Agents",
            accessor: "servers.length",
            filterMethod: fuzzySearch
        },
        {
            Header: "Actions",
            filterable: false,
            sortable: false,
            Cell: (data) => (<div className="action-btn">
                <Link className="btn btn-success" to={{ pathname: `/viewmanager/${data.original.manager_id}` }}>
                    <i className="fa fa-eye" id={"TooltipComponent"}></i> </Link>
                <button className="btn btn-danger" href="#" onClick={() => this.deleteConfirm(data.original.manager_id)}>
                    <i className="fa fa-trash-o" id={"Tooltips"}></i> </button>
                <UncontrolledTooltip placement="right" target={"TooltipComponent"}> View </UncontrolledTooltip>
                <UncontrolledTooltip placement="right" target={"Tooltips"}> Delete </UncontrolledTooltip>
            </div>
            ),
        }];

        return (
            <div> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>Managers</strong>
                            </CardHeader>
                            <CardBody>
                                <ReactTable
                                    columns={columns}
                                    data={managers}
                                    defaultSorted={[{id: "hostname"}]}
                                    loading={loading}
                                    filterable
                                    defaultPageSize={10}
                                    className="-striped -highlight site_table"
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>


                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className={this.props.className}>
                    <ModalHeader toggle={this.cancelDelete}>Delete Manager <i className="fa fa-bomb" aria-hidden="true"></i>
                    </ModalHeader>
                    <ModalBody>
                          Confirm Delete Manager?
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.deleteManagerAction} size="sm" color="danger"> <i className="fa fa-trash"></i> Delete</Button>
                        <Button onClick={this.cancelDelete} size="sm" color="basic"><i className="fa fa-ban"></i> Close</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Managers.propTypes = {
    getManagers: Proptypes.func.isRequired,
    deleteManager: Proptypes.func.isRequired,
    deleteManagerError: Proptypes.func,
    managers: Proptypes.array,
    getManagersLoading: Proptypes.bool,
    deleteManagerErrorMessage: Proptypes.func,
    className: Proptypes.func
};


export default connect(state => 
    ({
        managers: state.managers.managers || [],
        deleteManagerErrorMessage: state.managers.deleteManagerErrorMessage || null,
        getManagersLoading: state.managers.getManagersLoading || false,
        deleteManagerError: state.managers.deleteManagerError || null
    }),
dispatch => 
    ({  
        getManagers: () => dispatch(getManagers()),
        deleteManager: (data) => dispatch(deleteManager(data))
    }))(Managers);



// WEBPACK FOOTER //
// ./src/views/Managers/Managers.js